<template>
  <div class="common-title-page run-product-characteristics-page">
    <div class="title-size mb-30 text-center">
      Run Product Characteristics
    </div>
    <div class="max-w-800" style="margin: 20px auto;">
      <el-form
        :inline="true"
        :model="form"
        :rules="formRules"
        ref="form"
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$t('text.product')" prop="productId">
              <el-select
                v-model="form.productId"
                :placeholder="$t('text.please_select')"
                size="small"
                filterable
              >
                <el-option
                  v-for="item in products"
                  :key="item.id"
                  :label="item.productName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          v-for="(org, index) in form.organisations"
          :key="index"
          :gutter="20"
        >
          <el-col :span="6">
            <el-form-item
              label="Organisation"
              :prop="'organisations.' + index + '.organisationId'"
              :rules="{
                required: true,
                message: 'Please select organisation',
                trigger: 'change'
              }"
            >
              <el-select
                v-model="org.organisationId"
                size="small"
                :placeholder="$t('text.please_select')"
                filterable
              >
                <el-option
                  v-for="item in organisations"
                  :key="item.OrganisationId"
                  :label="item.OrganisationName"
                  :value="item.OrganisationId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="Date Range"
              :prop="'organisations.' + index + '.dateRange'"
              :rules="{
                required: true,
                message: 'Please select date range',
                trigger: 'blur'
              }"
            >
              <el-date-picker
                v-model="org.dateRange"
                format="dd/MM/yy HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="small"
                type="datetimerange"
                range-separator="-"
                start-placeholder="Start Date"
                end-placeholder="End Date"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="Offset"
              :prop="'organisations.' + index + '.offset'"
              :rules="{
                required: true,
                message: 'Please select offset',
                trigger: 'change'
              }"
            >
              <el-select
                v-model="org.offset"
                size="small"
                :placeholder="$t('text.please_select')"
                filterable
              >
                <el-option
                  v-for="item in utcOffsetOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="pt-25">
            <el-button
              type="danger"
              plain
              size="small"
              v-if="index !== 0"
              @click="removeOrgItem(index)"
              >Remove</el-button
            >
            <el-button
              type="primary"
              plain
              size="small"
              v-if="index === 0"
              @click="addOrgItem()"
              >Add</el-button
            >
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="Abl" prop="abl">
              <el-input-number
                v-model="form.abl"
                controls-position="right"
                size="small"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Min Percentage" prop="minPercentage">
              <el-input-number
                v-model="form.minPercentage"
                controls-position="right"
                size="small"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Max Percentage" prop="maxPercentage">
              <el-input-number
                v-model="form.maxPercentage"
                controls-position="right"
                size="small"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6"> </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="Sensor Epsilon" prop="sensorEpsilon">
              <el-input-number
                v-model="form.sensorEpsilon"
                controls-position="right"
                size="small"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Sensor MinPoint" prop="sensorMinPoint">
              <el-input-number
                v-model="form.sensorMinPoint"
                controls-position="right"
                size="small"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Volume Epsilon" prop="volumeEpsilon">
              <el-input-number
                v-model="form.volumeEpsilon"
                controls-position="right"
                size="small"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Volume MinPoint" prop="volumeMinPoint">
              <el-input-number
                v-model="form.volumeMinPoint"
                controls-position="right"
                size="small"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item class="text-right">
          <el-button
            type="primary"
            @click="submitForm('form')"
            :loading="saveLoading"
            >RUN</el-button
          >
          <el-button @click="clear('form')">Clear</el-button>
        </el-form-item>
      </el-form>
      <div v-show="result">
        <el-divider></el-divider>
        <div class="dark-font big-font text-center mb-10">Result</div>
        <el-row>
          <el-col :span="8">
            <span class="mr-5">Slope:</span>
            <span class="blue-font">{{ result ? result.Slope : '--' }}</span>
          </el-col>
          <el-col :span="8">
            <span class="mr-5">Intercept:</span>
            <span class="blue-font">{{
              result ? result.Intercept : '--'
            }}</span>
          </el-col>
          <el-col :span="8">
            <span class="mr-5">Equation:</span>
            <span class="blue-font">{{ result ? result.Equation : '--' }}</span>
          </el-col>
          <el-col :span="8">
            <span class="mr-5">MedianLowSensorValue:</span>
            <span class="blue-font">{{
              result ? result.MedianLowSensorValue : '--'
            }}</span>
          </el-col>
          <el-col :span="8">
            <span class="mr-5">MedianHighSensorValue:</span>
            <span class="blue-font">{{
              result ? result.MedianHighSensorValue : '--'
            }}</span>
          </el-col>
          <el-col :span="8">
            <span class="mr-5">MedianVolume:</span>
            <span class="blue-font">{{
              result ? result.MedianVolume : '--'
            }}</span>
          </el-col>
        </el-row>
        <div
          id="sensorClusterChart"
          class="mt-10"
          :style="{
            width: '100%',
            height: '400px'
          }"
        ></div>
        <div
          id="volumeClusterChart"
          class="mt-10"
          :style="{
            width: '100%',
            height: '400px'
          }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/CommonApiService.js'
import ReportApiService from '@/services/ReportApiService.js'
import swal from 'sweetalert'
import { utcOffsets } from '@/const'
export default {
  data() {
    return {
      utcOffsetOptions: utcOffsets,
      products: [],
      organisations: [],
      organisationsLoading: false,
      form: {
        productId: '',
        organisations: [
          {
            organisationId: '',
            offset: '',
            dateRange: []
          }
        ],
        abl: '',
        minPercentage: '',
        maxPercentage: '',
        sensorEpsilon: '',
        sensorMinPoint: '',
        volumeEpsilon: '',
        volumeMinPoint: ''
      },
      formRules: this.initFormRules(),
      saveLoading: false,
      pickerOptions: {
        disabledDate: time => {
          return time.getTime() > Date.now()
        }
      },
      result: null
    }
  },
  mounted() {
    this.getProducts()
    this.getOrganisations()
  },
  methods: {
    initFormRules() {
      return {
        productId: [
          {
            required: true,
            message: this.$t('text.product_required'),
            trigger: 'change'
          }
        ]
      }
    },
    getProducts() {
      const user = JSON.parse(localStorage.getItem('user'))
      ApiService.GetProductsById(user.id).then(response => {
        this.products = response.data.data
      })
    },
    getOrganisations() {
      this.organisationsLoading = true
      ReportApiService.GetAllOrganisations(this.filter)
        .then(response => {
          this.organisationsLoading = false
          if (response.data.success) {
            let organisations = response.data.data
            this.organisations = []
            organisations.forEach(item => {
              item.Organisations.forEach(org => {
                this.organisations.push(org)
              })
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.organisationsLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    addOrgItem() {
      this.form.organisations.push({
        organisationId: '',
        offset: '',
        dateRange: []
      })
    },
    removeOrgItem(index) {
      this.form.organisations.splice(index, 1)
    },
    clear(formName) {
      this.$refs[formName].resetFields()
      this.result = null
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.hasDuplicateOrganisationId()) {
            swal({
              icon: 'warning',
              title: 'Warning',
              text: 'Duplicate organisations cannot be added'
            })
          } else {
            this.handleSubmit()
          }
        }
      })
    },
    hasDuplicateOrganisationId() {
      let ids = new Set()
      for (let org of this.form.organisations) {
        if (ids.has(org.organisationId)) {
          return true
        }
        ids.add(org.organisationId)
      }
      return false
    },
    handleSubmit() {
      this.saveLoading = true
      let params = {
        ProductId: this.form.productId,
        Abl: this.form.abl,
        MinPercentage: this.form.minPercentage,
        MaxPercentage: this.form.maxPercentage,
        SensorEpsilon: this.form.sensorEpsilon,
        SensorMinPoint: this.form.sensorMinPoint,
        VolumeEpsilon: this.form.volumeEpsilon,
        VolumeMinPoint: this.form.volumeMinPoint,
        OrganisationDate: this.form.organisations.map(org => {
          return {
            OrganisationId: org.organisationId,
            OffSet: org.offset,
            FromDate: org.dateRange[0],
            ToDate: org.dateRange[1]
          }
        })
      }
      ReportApiService.GetAllCharacterisationData(params)
        .then(response => {
          this.saveLoading = false
          if (response.data.success) {
            this.result = response.data.data
            if (this.result.SensorCluster) {
              let sensorClusterData = this.result.SensorCluster.map(item => {
                return [item.Value, item.ClusterNumber]
              })
              this.initChart(
                'sensorClusterChart',
                sensorClusterData,
                'Sensor Cluster'
              )
            }
            if (this.result.VolumeCluster) {
              let volumeClusterData = this.result.VolumeCluster.map(item => {
                return [item.Value, item.ClusterNumber]
              })
              this.initChart(
                'volumeClusterChart',
                volumeClusterData,
                'Volume Cluster'
              )
            }
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: 'Failed',
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.saveLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: 'Failed'
          })
        })
    },
    initChart(domClassName, data, title) {
      if (!domClassName) return false
      var dom = document.getElementById(domClassName)
      let chart = this.echarts.init(dom)
      chart.setOption({
        title: {
          text: title,
          top: 'top',
          left: 'center'
        },
        xAxis: {
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        yAxis: {
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          },
          scale: true
        },
        tooltip: {
          formatter: function(param) {
            return `Cluster Number: ${param.data[1]}<br/>Value: ${
              param.data[0]
            }`
          }
        },
        series: [
          {
            symbolSize: 10,
            data,
            type: 'scatter',
            itemStyle: {
              color:
                domClassName === 'sensorClusterChart'
                  ? new this.echarts.graphic.RadialGradient(0.4, 0.3, 1, [
                      {
                        offset: 0,
                        color: 'rgb(251, 118, 123)'
                      },
                      {
                        offset: 1,
                        color: 'rgb(204, 46, 72)'
                      }
                    ])
                  : new this.echarts.graphic.RadialGradient(0.4, 0.3, 1, [
                      {
                        offset: 0,
                        color: 'rgb(129, 227, 238)'
                      },
                      {
                        offset: 1,
                        color: 'rgb(25, 183, 207)'
                      }
                    ])
            }
          }
        ]
      })
      window.addEventListener('resize', function() {
        chart.resize()
      })
      this.$nextTick(() => {
        chart.resize()
      })
    }
  }
}
</script>

<style lang="scss">
.run-product-characteristics-page {
  .el-form--inline .el-form-item__label {
    line-height: unset;
    padding: 0;
    margin-bottom: 0;
  }

  .el-form-item {
    width: 100%;

    .el-select,
    .el-input,
    .el-date-editor {
      width: 100%;
    }
  }
}
</style>
